import "./PerformanceHero.css";

export interface MetricChipProps {
  label: string;
  /** Already-formatted display value, or null to show a loading skeleton. */
  display: string | null;
  /** Optional small caption below the value, e.g. "Ne ulazi u obračun učinka." */
  sub?: string;
  /** Visually de-emphasized treatment (dashed border, muted background) — for supporting/contextual metrics that should never compete with a primary metric. */
  secondary?: boolean;
}

/**
 * The shared compact metric block — used by both Analytics
 * (`PerformanceOverview`'s supporting chips) and Dashboard's own
 * completeness/operational-context blocks. Pure presentation only, same
 * reasoning as `PerformanceHero`.
 */
export function MetricChip({ label, display, sub, secondary }: MetricChipProps) {
  return (
    <div className={["nx-metric-chip", secondary ? "nx-metric-chip--secondary" : ""].filter(Boolean).join(" ")}>
      <p className="nx-metric-chip__label">{label}</p>
      {display === null ? (
        <span className="nx-skeleton" style={{ width: "60px", height: "22px" }} />
      ) : (
        <p className="nx-metric-chip__value">{display}</p>
      )}
      {sub && display !== null ? <p className="nx-metric-chip__sub">{sub}</p> : null}
    </div>
  );
}
